import React from 'react';
import { LineChart, TrendingUp, Shield, Users, Briefcase, BarChart2 } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    title: 'Equity Trading',
    description: 'Access to NSE and BSE markets with competitive brokerage rates and advanced trading platforms.',
    icon: <LineChart className="h-8 w-8 text-blue-600" data-id="element-227" />
  }, {
    title: 'Derivatives Trading',
    description: 'Trade futures and options with expert guidance and risk management strategies.',
    icon: <TrendingUp className="h-8 w-8 text-blue-600" data-id="element-228" />
  }, {
    title: 'Mutual Funds',
    description: 'Invest in a wide range of mutual funds with zero commission and systematic investment plans.',
    icon: <Shield className="h-8 w-8 text-blue-600" data-id="element-229" />
  }, {
    title: 'Portfolio Management',
    description: 'Personalized portfolio management services tailored to your financial goals and risk appetite.',
    icon: <Briefcase className="h-8 w-8 text-blue-600" data-id="element-230" />
  }, {
    title: 'IPO Investments',
    description: 'Seamless application process for Initial Public Offerings (IPOs) in the primary market.',
    icon: <Users className="h-8 w-8 text-blue-600" data-id="element-231" />
  }, {
    title: 'Research & Advisory',
    description: 'Data-driven research and personalized investment advisory services for informed decisions.',
    icon: <BarChart2 className="h-8 w-8 text-blue-600" data-id="element-232" />
  }];
  return <section id="services" className="py-16 bg-white" data-id="element-233">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-234">
        <div className="text-center mb-16" data-id="element-235">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-236">Our Services</h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-237">
            We offer a comprehensive range of financial services to help you
            achieve your investment goals with confidence.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-238">
          {services.map((service, index) => <div key={index} className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow" data-id="element-239">
              <div className="mb-4" data-id="element-240">{service.icon}</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-241">
                {service.title}
              </h3>
              <p className="text-gray-600" data-id="element-242">{service.description}</p>
            </div>)}
        </div>
        <div className="mt-16 text-center" data-id="element-243">
          <a href="#contact" className="inline-block bg-blue-800 text-white px-6 py-3 rounded-md font-medium hover:bg-blue-700" data-id="element-244">
            Get Started Today
          </a>
        </div>
      </div>
    </section>;
}